import { ClockSubcomponent } from "appworks/components/header/clock-component";
import { HeaderComponent } from "appworks/components/header/header-component";
import { SoundToggleComponent } from "appworks/components/sound/sound-toggle-component";
import { FlexiSprite } from "appworks/graphics/elements/flexi-sprite";
import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { AgsSoundToggleComponent } from "./ags-sound-toggle-component";

export class AgsHeaderComponent extends HeaderComponent {
    protected createClock() {
        const clock = new ClockSubcomponent();
        clock.setVisible(gameiomModel.displayClock);
        return clock;
    }

    protected setupSoundToggle(): void {
        const layer = Layers.get("MuteButton");
        if (!layer) { return; }

        layer.defaultScene().then(() => {
            if (this.soundToggle) {
                this.soundToggle.destroy();
                this.soundToggle = null;
            }

            const soundOnButton = layer.getFlexiButton("sound_toggle_on");
            if (soundOnButton) {
                const soundOffButton = layer.getFlexiButton("sound_toggle_off");
                const soundLoading: FlexiSprite = layer.getFlexiSprite("sound_toggle_loading");
                this.soundToggle = new AgsSoundToggleComponent(soundOnButton, soundOffButton, soundLoading);
            }
        });
    }
}
